import { IDataSet } from '../Track';


export class QuestDataSet implements IDataSet {
    public qQuestName: string = undefined;
    public qQuestID: string = undefined;
    public qQuestTier: number = 0;
}
